module.exports = __webpack_public_path__ + "static/media/ON_logo_blanco.92ad8b89.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/ON_logo_blanco.png
// module id = 45
// module chunks = 0